// import React, { useEffect, useState } from "react";
// import classes from "./SideMenu.module.css";
// import SideMenuData from "./SideMenuData";
// import { GrClose } from "react-icons/gr";
// import useHttp from "../../Hooks/use-http";

// let sideMenuFlag = 0;
// let flag = false;
// let prev_corp = "";
// let obj = {
//   dashboard: "<AiOutlineBarChart />",
// };

// const SideMenu = (props) => {
//   const [sideMenuData, setSideMenuData] = useState([]);
//   const { sendRequest } = useHttp();

//   const menuList = (data) => {
//     let menu = data?.MainMenuList?.reduce((acc, cur, index) => {
//       acc[index] = {
//         main: cur?.Description,
//       };
//       let arr = [];
//       for (let i = 0; i < data?.MenuList?.length; i++) {
//         if (cur?.MainModuleID === data?.MenuList[i]?.MainModuleID)
//           arr.push({
//             main: data?.MenuList[i]?.ModuleName,
//             url: data?.MenuList[i]?.MenuURL,
//           });
//       }
//       if (arr?.length === 1) acc[index].url = arr[0].url;
//       else acc[index].sub = arr;
//       arr = [];
//       return acc;
//     }, []);
//     setSideMenuData(menu);
//   };

//   useEffect(() => {
//     // if (sideMenuFlag > 0) {
//     sendRequest(
//       {
//         url: "/api/v1/Menu/GetUserMenuList",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           corporateID:
//             localStorage.getItem("roleId") === "1"
//               ? ""
//               : localStorage.getItem("corpId"),
//         },
//       },
//       menuList
//     );
//   }, []);

//   const changeMenuWidth = () => {
//     // alert(document.getElementById("mySidemenu")?.style?.width);
//     if (
//       window.screen.width < 450 &&
//       document.getElementById("mySidemenu").style.width !== null
//     ) {
//       if ((document.getElementById("mySidemenu").style.width = "100%"))
//         document.getElementById("mySidemenu").style.minWidth = "100%";
//     } else {
//       if (
//         (document.getElementById("mySidemenu").style.width =
//           "25%" && document.getElementById("mySidemenu").style.width !== null)
//       )
//         document.getElementById("mySidemenu").style.minWidth = "25%";
//     }
//     // The URL changed...
//     window.removeEventListener("popstate", changeMenuWidth);
//   };

//   if (
//     props.property &&
//     document.getElementById("mySidemenu").style.width !== null
//   ) {
//     if (
//       window.screen.width < 450 &&
//       document.getElementById("mySidemenu").style.width !== null
//     )
//       document.getElementById("mySidemenu").style.width = "100%";
//     else document.getElementById("mySidemenu").style.width = "20%";
//     // debugger;
//     window.addEventListener("popstate", changeMenuWidth);
//     flag = true;
//   } else {
//     if (flag) {
//       if (document.getElementById("mySidemenu")) {
//         document.getElementById("mySidemenu").style.minWidth = "0px";
//         document.getElementById("mySidemenu").style.width = "0px";
//       }
//     }
//   }

//   return (
//     <div className={classes.menuContainer} id="mySidemenu">
//       <div
//         className={classes.subMenu}
//         onMouseLeave={() => props.sideMenuClose()}
//       >
//         <div
//           className={classes.closeIcon}
//           onClick={() => props.sideMenuClose()}
//         >
//           <GrClose />
//         </div>
//         {/* {!sideMenuData[0] && (
//           <div style={{ textAlign: "center", marginTop: "20px" }}>
//             No Data Available
//           </div>
//         )} */}
//         {sideMenuData?.length === 0 && (
//           <div style={{ textAlign: "center", marginTop: "20px" }}>
//             No Data Available
//           </div>
//         )}
//         {/* <SideMenuData
//           menu={sideMenuData}
//           iconFlag={true}
//           sideMenuClose={props.sideMenuClose}
//         /> */}

//         {sideMenuData?.length > 0 && (
//           <SideMenuData
//             menu={sideMenuData}
//             iconFlag={true}
//             sideMenuClose={props.sideMenuClose}
//           />
//         )}
//         <p style={{ color: "gray", marginTop: "20%", fontSize: "10px" }}>
//           Last Updated on 09/13/2024
//         </p>
//       </div>
//     </div>
//   );
// };

// export default SideMenu;

import React, { useEffect, useState } from "react";
import classes from "./SideMenu.module.css";
import SideMenuData from "./SideMenuData";
import { GrClose } from "react-icons/gr";
import { useSettings } from "../../Hooks/useUnifiedApi";
import { useAuth } from "../../Hooks/useAuth";

let flag = false;

const SideMenu = (props) => {
  const [sideMenuData, setSideMenuData] = useState([]);
  const [menuLoaded, setMenuLoaded] = useState(false);
  // Use settings service for menu operations
  const { customCall, loading: isLoading, error } = useSettings();
  const { getUserEmail, getCorporateId, hasRole, user, isAuthenticated } = useAuth();

  // Fallback menu based on enabled modules for when backend returns no menu data
  const getDefaultMenu = () => {
    const enabledModule = localStorage.getItem("enabledModule") || "";
    const modules = enabledModule.toLowerCase().split(",").map(m => m.trim());
    
    const menu = [
      { main: "Dashboard", url: "/dashboard" },
    ];

    // Add menu items based on enabled modules
    if (modules.includes("shuttle")) {
      menu.push({
        main: "Shuttle",
        sub: [
          { main: "Trips", url: "/trips?type=shuttle" },
          { main: "Routes", url: "/routes" },
          { main: "Stops", url: "/stops" },
          { main: "Drivers", url: "/shuttle-drivers" },
        ]
      });
    }

    if (modules.includes("private")) {
      menu.push({
        main: "Private",
        sub: [
          { main: "Trips", url: "/trips?type=private" },
          { main: "Drivers", url: "/private-drivers" },
          { main: "Bookings", url: "/bookings" },
        ]
      });
    }

    if (modules.includes("schedule")) {
      menu.push({
        main: "Schedule",
        sub: [
          { main: "New Booking", url: "/new-booking" },
          { main: "Bookings", url: "/schedule-bookings" },
        ]
      });
    }

    // Common items for corporate admin
    menu.push(
      { main: "Staff", url: "/staff" },
      { main: "Reports", url: "/reports" }
    );

    console.log('📋 [SIDE_MENU] Using default menu based on enabledModule:', enabledModule, menu);
    return menu;
  };

  const menuList = (data) => {
    console.log('🔍 [SIDE_MENU] Menu API Response:', data);
    console.log('🔍 [SIDE_MENU] Menu API Response Type:', typeof data);
    console.log('🔍 [SIDE_MENU] Menu API Response Keys:', data ? Object.keys(data) : 'null');
    console.log('🔍 [SIDE_MENU] MainMenuList:', data?.MainMenuList);
    console.log('🔍 [SIDE_MENU] MenuList:', data?.MenuList);

    // Handle null or error responses gracefully
    if (!data || data === null || !data.MainMenuList) {
      console.warn('⚠️ [SIDE_MENU] No menu data from API - using default menu based on enabledModule');
      console.warn('⚠️ [SIDE_MENU] Data received:', data);
      // Use default menu based on enabled modules when API returns empty data
      const defaultMenu = getDefaultMenu();
      setSideMenuData(defaultMenu);
      setMenuLoaded(true);
      return;
    }

    // Handle API errors (like 404)
    if (data.error || data.status >= 400) {
      console.warn('Menu API error:', data);
      const defaultMenu = getDefaultMenu();
      setSideMenuData(defaultMenu);
      setMenuLoaded(true);
      return;
    }

    let menu = data?.MainMenuList?.reduce((acc, cur, index) => {
      acc[index] = {
        main: cur?.Description,
      };
      let arr = [];
      for (let i = 0; i < data?.MenuList?.length; i++) {
        if (cur?.MainModuleID === data?.MenuList[i]?.MainModuleID)
          arr.push({
            main: data?.MenuList[i]?.ModuleName,
            url: data?.MenuList[i]?.MenuURL,
          });
      }
      if (arr?.length === 1) acc[index].url = arr[0].url;
      else acc[index].sub = arr;
      arr = [];
      return acc;
    }, []);
    console.log('Final processed menu:', menu);
    setSideMenuData(menu);
    setMenuLoaded(true);
  };

  useEffect(() => {
    console.log('Making menu request...');

    const userEmail = getUserEmail();
    const corporateId = hasRole("1") ? "" : getCorporateId();

    if (userEmail && isAuthenticated && user) {
      const fetchMenuList = async () => {
        try {
          console.log('Starting menu list fetch...');
          console.log('Menu params:', {
            emailID: userEmail,
            corporateID: corporateId || "",
          });

          const response = await customCall('GET_USER_MENU_LIST', {
            emailID: userEmail,
            corporateID: corporateId || "",
          });

          console.log('Unified API response received:', response);
          console.log('Response status:', response?.Status);
          console.log('Response message:', response?.Message);
          console.log('Response type:', typeof response);
          console.log('Response keys:', response ? Object.keys(response) : 'null');
          console.log('Full response object:', JSON.stringify(response, null, 2));
          console.log('Calling menuList() to process response...');
          menuList(response);
        } catch (error) {
          console.error('Failed to fetch menu list:', error);
          console.error('Error details:', error.message);
          // Fallback to empty menu on error
          setSideMenuData([]);
          setMenuLoaded(true); // Mark as loaded even on error to prevent retries
        }
      };

      fetchMenuList();
    } else {
      console.warn('User not authenticated or no email available for menu request');
    }
  }, [customCall, isAuthenticated, user, getUserEmail, getCorporateId, hasRole, menuLoaded]);

  // Handle API errors
  useEffect(() => {
    if (error) {
      console.warn('Menu API error:', error);
      setSideMenuData([]);
      setMenuLoaded(true);
      // Don't break the component, just show "No Data Available"
    }
  }, [error]);

  const changeMenuWidth = () => {
    const sideMenuElement = document.getElementById("mySidemenu");

    // Ensure the element exists before proceeding
    if (!sideMenuElement) {
      console.warn("SideMenu element not found.");
      return;
    }

    if (window.screen.width < 450) {
      sideMenuElement.style.width = "100%";
      sideMenuElement.style.minWidth = "100%";
    } else {
      sideMenuElement.style.width = "25%";
      sideMenuElement.style.minWidth = "25%";
    }
  };

  useEffect(() => {
    const sideMenuElement = document.getElementById("mySidemenu");

    // Ensure the element exists before trying to access it
    if (props.property && sideMenuElement) {
      if (window.screen.width < 450) {
        sideMenuElement.style.width = "100%";
      } else {
        sideMenuElement.style.width = "20%";
      }

      window.addEventListener("popstate", changeMenuWidth);
      flag = true;
    } else if (flag && sideMenuElement) {
      sideMenuElement.style.minWidth = "0px";
      sideMenuElement.style.width = "0px";
    }

    // Clean up event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", changeMenuWidth);
    };
  }, [props.property]);

  return (
    <div className={classes.menuContainer} id="mySidemenu">
      <div
        className={classes.subMenu}
        onMouseLeave={() => props.sideMenuClose()}
      >
        <div
          className={classes.closeIcon}
          onClick={() => props.sideMenuClose()}
        >
          <GrClose />
        </div>
        {sideMenuData?.length === 0 && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            No Data Available
          </div>
        )}
        {sideMenuData?.length > 0 && (
          <SideMenuData
            menu={sideMenuData}
            iconFlag={true}
            sideMenuClose={props.sideMenuClose}
          />
        )}
        <p
          style={{
            color: "gray",
            marginTop: "20%",
            fontSize: "10px",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          Last Updated on 12 Mar 2025, 14:13
        </p>
      </div>
    </div>
  );
};

export default SideMenu;
